import {
  Button, IconLoading, IconSuccessShield, Modal,
} from 'gatorcomponents';
import React, { Fragment } from 'react';
import * as Styles from './DisconnectAccountModal.styles';
import MetaDisconnectImage from '@/media/MultiAgentsHome/meta-disconnect-image.png';
import { STEPS } from './DisconnectAccountModal.enum';

const DisconnectAccountModal = ({
  onClose,
  stepLocale,
  handleDisconnect,
  unlinkModalStep,
  setUnlinkModalStep,
}) => {
  const handleClickDisconnect = () => {
    setUnlinkModalStep(STEPS.LOADING);
    handleDisconnect && handleDisconnect();
  };

  const stepContent = {
    [STEPS.ASKING_FOR_CONFIRMATION]: (
      <>
        <Styles.Image src={MetaDisconnectImage} />

        <Styles.MainTitle>
          {stepLocale[0].title}
        </Styles.MainTitle>

        <Styles.CardItemsBlock>
          {stepLocale[0].items.map(item => (
            <Fragment key={JSON.stringify(item)}>
              <Styles.CardItemTitle>
                {item.id === 'IconSuccessShield' && <IconSuccessShield />}
                {item.title}
              </Styles.CardItemTitle>
              <Styles.List>
                {item.childs.map(child => (
                  <Styles.CardItemDescription key={child}>{child}</Styles.CardItemDescription>
                ))}
              </Styles.List>
            </Fragment>
          ))}
        </Styles.CardItemsBlock>

        <Styles.ActionRow>
          <Button size="medium2" variant="primary" label={stepLocale[0].keepLabel} onClick={onClose} />
          <Button
            size="medium2"
            negative
            variant="secondary"
            label={stepLocale[0].disconnectLabel}
            onClick={handleClickDisconnect}
          />
        </Styles.ActionRow>
      </>
    ),
    [STEPS.LOADING]: (
      <Styles.LoadingWrapper>
        <IconLoading />
        <Styles.LoadingText>
          {stepLocale[1].loadingText}
        </Styles.LoadingText>
      </Styles.LoadingWrapper>
    ),
    [STEPS.SUCCESS]: (
      <Styles.LoadingWrapper>
        <Styles.MainTitle>
          {stepLocale[2].title}
        </Styles.MainTitle>

        <Styles.Description>
          {stepLocale[2].description}
        </Styles.Description>

        <Styles.ActionRow>
          <Button
            variant="secondary"
            size="medium2"
            label={stepLocale[2].cta}
          />
        </Styles.ActionRow>
      </Styles.LoadingWrapper>
    ),
  };


  return (
    <Modal onClose={onClose} maxHeight="800px">
      {stepContent[unlinkModalStep]}
    </Modal>
  );
};

export default DisconnectAccountModal;
